import { render } from "./XIconSolidHeadCircuit.vue?vue&type=template&id=3831e7db"
import script from "./XIconSolidHeadCircuit.vue?vue&type=script&lang=js"
export * from "./XIconSolidHeadCircuit.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidHeadCircuit.vue"]])

export default __exports__